Vue.component('course-pricing-ind', require('./components/CoursePricingIndividual.vue').default)
Vue.component('course-pricing-grp', require('./components/CoursePricingGroup.vue').default)

const Pricing = new Vue({
    el: '#pills-dates',
})

window.Pricing = Pricing
